function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$(document).ready(function () {
    if ( $(window).width() < 1023 ) {
        // if window is mobile, show loox underneath add to cart
        $('.loox-reviews-container-desktop').remove();
    }
  
  // if current min is less than 15, show classic view button
  var today = new Date();
  var current_min = today.getMinutes();

  if (getCookie("classic_holster_wizard") == "") {
    if (current_min <= 15) {
      setCookie("classic_holster_wizard", "true", 1);

      ga("send", {
        hitType: "event",
        eventCategory: "Holster Wizard",
        eventAction: "classic_holster_wizard_trial",
        eventLabel: "Classic Holster Wizard Trial Group",
      });
    } else {
      setCookie("classic_holster_wizard", "false", 1);

      ga("send", {
        hitType: "event",
        eventCategory: "Holster Wizard",
        eventAction: "classic_holster_wizard_control",
        eventLabel: "Classic Holster Wizard Control Group",
      });
    }
  }

  if (getCookie("classic_holster_wizard") == "true") {
    $(".bold-options-wrapper").addClass("show");
  }
  

  // see classic view of bold options
  $(".classic-title").on("click tap", function () {
    $(this).hide();
    $(".bold-options-wrapper").css("max-height", "100%");

    ga("send", {
      hitType: "event",
      eventCategory: "Holster Wizard",
      eventAction: "classic_holster_wizard_trial_clicked",
      eventLabel: "See Classic Holster Wizard Clicked",
    });
  });

  if (window.location.pathname == "/challenge") {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  /*============================================================================
    Cart
  ==============================================================================*/
  $(".button-edit-mobile-cart").on("click tap", function (e) {
    e.preventDefault();

    var $hiddenElem = $(
      "#your-shopping-cart .cart-table tbody>tr td:nth-child(3), #your-shopping-cart .cart-table tbody>tr td:nth-child(4)"
    );

    var $price = $(this).closest(".cart__row").find("[data-label='Price']");
    var $quantity = $(this)
      .closest(".cart__row")
      .find("[data-label='Quantity']");

    $price.toggleClass("active");
    $quantity.toggleClass("active");
  });

  // update little green quantity on mobile
  $(".update-input").on("change keypress", function () {
    var updated_quantity = $(this).val();
    $(this)
      .parent()
      .siblings(".product-td")
      .children(".cart__image")
      .attr("data-count", updated_quantity);
  });

  /*============================================================================
    Terms and Conditions Disclaimer on cart.liquid via toggle/switch
    ==============================================================================*/
  $(".no-refund-switch input").change(function (e) {
    if (this.checked) {
      $(".cart_page_checkout_button")
        .removeAttr("disabled")
        .removeClass("disabled");
    } else {
      $(".cart_page_checkout_button")
        .attr("disabled", "true")
        .addClass("disabled");
    }
  });

  /*============================================================================
    Quantity Product Box on Mobile
    ==============================================================================*/
  (function (i) {
    var e = /iPhone/i,
      n = /iPod/i,
      o = /iPad/i,
      t = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
      r = /Android/i,
      d = /BlackBerry/i,
      s = /Opera Mini/i,
      a = /IEMobile/i,
      b = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
      h = RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)", "i"),
      c = function (i, e) {
        return i.test(e);
      },
      l = function (i) {
        var l = i || navigator.userAgent;
        (this.apple = {
          phone: c(e, l),
          ipod: c(n, l),
          tablet: c(o, l),
          device: c(e, l) || c(n, l) || c(o, l),
        }),
          (this.android = {
            phone: c(t, l),
            tablet: !c(t, l) && c(r, l),
            device: c(t, l) || c(r, l),
          }),
          (this.other = {
            blackberry: c(d, l),
            opera: c(s, l),
            windows: c(a, l),
            firefox: c(b, l),
            device: c(d, l) || c(s, l) || c(a, l) || c(b, l),
          }),
          (this.seven_inch = c(h, l)),
          (this.any =
            this.apple.device ||
            this.android.device ||
            this.other.device ||
            this.seven_inch);
      },
      v = (i.isMobile = new l());
    v.Class = l;
  })(window);

  if (
    isMobile.android.phone ||
    isMobile.apple.phone ||
    isMobile.apple.ipod ||
    isMobile.other.opera ||
    isMobile.other.firefox ||
    isMobile.other.blackberry
  ) {
    //inside the mobile function
    $(".template-product .quantity-selector")
      .css("padding-top", "8px")
      .css("padding-bottom", "5px")
      .css("padding-left", "11px")
      .css("padding-right", "11px");

    /*============================================================================
            Index Collection Carousel on Mobile
            ==============================================================================*/
    // $('.template-index #CollectionSection .container').slick({
    //     dots: false,
    //     infinite: true,
    //     slidesToShow: 2,
    //     arrows: false,
    // });
  }

  /*============================================================================
    See More Tags
    ==============================================================================*/
  $(".collection-see-more-tags").on("click tap", function () {
    $(this).hide();
    $(".collection-tag-sidebar")
      .css("height", "100%")
      .css("max-height", "100%");
  });

  /*============================================================================
    Product Page Tabs for Descriptions and Reviews
    ==============================================================================*/
  $("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  /*============================================================================
     Nav fade in
    ==============================================================================*/
  window.setTimeout(function () {
    $(".template-index .nav-bar").css("opacity", "1");
  }, 100);

  /*============================================================================
    Hover Effect on 'From The Blog'
    ==============================================================================*/
  $(".blog-link-a").each(function () {
    $(this).hover(function () {
      $(this).next().toggleClass("hover-effect");
    });
  });

  /*============================================================================
    Hero Slick Carousel
    ==============================================================================*/
  $("#Hero").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    nextArrow: "#slideshow .arrows-container .right",
    prevArrow: "#slideshow .arrows-container .left",
    adaptiveHeight: true,
  });

  /*============================================================================
    Testimonials Slick Carousel
    ==============================================================================*/
  $("#testimonial-hero").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    nextArrow: "#testimonials .arrows-container .right",
    prevArrow: "#testimonials .arrows-container .left",
  });

  /*============================================================================
    Home Page Collection Slick Carousel
    ==============================================================================*/
  // $('#collection-grid').slick({
  //     dots: false,
  //     infinite: true,
  //     slidesToShow: 4,
  //     autoplay: true,
  //     autoplaySpeed: 4000,
  //     nextArrow: '#shopify-section-1513811742073 .arrows-container .right',
  //     prevArrow: '#shopify-section-1513811742073 .arrows-container .left',
  //     responsive: [
  //     {
  //        breakpoint: 1100,
  //        settings: {
  //            slidesToShow: 4,
  //        }
  //     },
  //     {
  //        breakpoint: 1090,
  //        settings: {
  //            slidesToShow: 3,
  //        }
  //     },
  //     {
  //        breakpoint: 900,
  //        settings: {
  //            slidesToShow: 2,
  //        }
  //     },
  //    {
  //        breakpoint: 640,
  //        settings: {
  //            slidesToShow: 1,
  //        }
  //    }
  //  ]
  // });

  /*============================================================================
    Related Products Carousel
    ==============================================================================*/
  $(".related-products-carousel-container .container").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    nextArrow: ".fa-caret-right",
    prevArrow: ".fa-caret-left",
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  /*============================================================================
    Product carousel on mobile
    ==============================================================================*/
  $(".mobile-carousel").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    customPaging: function (slider, i) {
      return '<div class="pager__item" id=' + i + ">  </div>";
    },
    useTransform: true,
    cssEase: "ease-in-out",
    nextArrow: ".fa-caret-right",
    prevArrow: ".fa-caret-left",
  });

  /* ==========================================================================
    #Changing Selects for Radio Buttons for mobile
    ========================================================================== */
  if ($(window).width() < 1023) {
    if ($(".mobile-price").length)
      $(".mobile-price").attr("id", "ProductOriginalPrice");

    if ($(".single-option-selector").length) {
      var $selectElem = $(".single-option-selector"),
        $radioContainer = $("#radio-options-wrapper"),
        radioOptionsItemHtml = "";

      // iterating over the select elements

      $selectElem.each(function (index) {
        var $self = $(this),
          selectTitle = $(this).prev("label").text().trim(),
          elemNumber = index;

        radioOptionsItemHtml += "<div class='radio-options-item'>";
        radioOptionsItemHtml +=
          "<span class='radio-item-title'>" +
          selectTitle +
          "</span><div class='custom-variant-options'>";
        // iterating over the option elements
        $self.children("option").each(function (index, elem) {
          var isChecked = elem.selected ? "checked" : "",
            radioId = elemNumber + "-" + index;

          radioOptionsItemHtml +=
            "<input type='radio' id='option-" +
            radioId +
            "' name='radio-option-" +
            elemNumber +
            "' value='" +
            elem.value +
            "' data-elem-index='" +
            elemNumber +
            "'" +
            isChecked +
            "><label for='option-" +
            radioId +
            "' style='cursor:pointer'>" +
            elem.value +
            "</label>";
        });

        radioOptionsItemHtml += "</div></div>";
      });

      // adding the html to the $radioContainer
      $radioContainer.html(radioOptionsItemHtml).addClass("active");

      // if the first variant is 'default title', hide it and do not show it
      if ($('label[for="option-0-0"]').text() == "Default Title") {
        $('label[for="option-0-0"]').hide();
      }

      // when clicking, it will trigger a change on the hidden select tag
      $(".custom-variant-options > input[type='radio']").on("change", function () {
        var currentValue = $(this).val(),
          currentIndex = $(this).data("elem-index");

        $("#productSelect-option-" + currentIndex)
          .val(currentValue)
          .trigger("change");
      });
    }
  }
});

/* =============
  T1 Customizations
============= */

(function ($) {
  $(document).ready(function () {
    $(".quantity-button").unbind().click(function () {
      var $button = $(this);
      var $qty = $button.parent().find("input");
      var qtyVal = +$qty.val();

      if ($button.hasClass("quantity-minus") && qtyVal > 1) {
        qtyVal--;
        $qty.val(qtyVal);
      } else if ($button.hasClass("quantity-plus")) {
        qtyVal++;
        $qty.val(qtyVal);
      }
    });

    // Axis Elite Bug Fix
    if (
      $(".dd_1010926_401267").length > 0 &&
      $(".dd_1010926_401267").val() !== ""
    ) {
      var weaponLight = document.querySelector(".dd_1010926_401267");
      var event = new Event("change");

      weaponLight.dispatchEvent(event);
    }

    /* =============
      Holster Product Modifications
    ============= */

    // Cart

    $(".template-cart .cart__row").each(function () {
      var $cart_row = $(this);
      var $button_edit = $cart_row.find(".bold_cart_edit_button");
      var $button_wrapper = $cart_row.find(".button_wrapper");

      $button_wrapper.append($button_edit);
    });

    /* ================
      Holster Product Line Item Modifications
    ================ */

    // Hiding Line Item Properties that have None as the value
    if ($(".product-customizer-line-item-prop").length) {
      var $line_prop_array = $(".product-customizer-line-item-prop");

      $line_prop_array.each(function () {
        var $line_prop = $(this);
        var line_prop_value = $line_prop
          .find(".option-value")
          .text()
          .trim()
          .toLowerCase();
        var line_prop_name = $line_prop
          .find(".option-name")
          .text()
          .trim()
          .toLowerCase();

        if (
          line_prop_name !== "sweat guard:" &&
          (line_prop_value === "no" ||
            line_prop_value === "none" ||
            line_prop_value === "no thanks")
        ) {
          $line_prop.addClass("hidden");
          $line_prop.prev("br").addClass("hidden");
        }
      });
    }

    /*===
      Functions
    ===*/

    $(".cart_page_checkout_button_clone").on("click tap", function (e) {
      var $button = $(this);
      var button_text = $button.text();

      $button
        .html(`<i class="fas fa-spinner fa-spin"></i> ${button_text}`)
        .addClass("button-loading");

      $("#cart_page_checkout_button")[0].click();

    });

    /*===
      SO
    ===*/

    if ($(".instafeed-lazyload").length) {
      var $instafeed = $(".instafeed-lazyload");
      var added_instafeed = false;
      var instafeed_position = $instafeed.offset().top;
      var instafeed_html = `
        <div class="text-center">
          <h2 class="text-uppercase section-header__title">
              Follow @tier1concealed
              <a href="https://www.instagram.com/tier1concealed/" target="_blank" rel="noreferrer" title="Tier 1 Concealed's Instagram">
                  <i class="fab fa-instagram" aria-hidden="true"></i>
              </a>
          </h2>
        </div>
        <div id="insta-feed"></div>`;
  
      $(window).on("scroll", function () {
  
        var current_scroll_bottom = $(this).scrollTop() + $(window).outerHeight();
  
        if (current_scroll_bottom >= instafeed_position && !added_instafeed) {
          added_instafeed = true;
          $instafeed.html(instafeed_html);
          instafeedApp();
        }
  
      })
  
    }

    $(window).on("load", function () {
      var $video_hero = $("video#test");

      if ($video_hero.length) {
        $video_hero[0].play();
      }
    });


    /* ======
      Pagination
    ====== */

    if ($("body.template-collection").length > 0 && $(".pagination").length > 0 && $(".pagination .page:not(.current)").length > 0) {

      var $pages = $(".pagination .page:not(.current)");
      var page_location = location.href;
      var last_page_number = +$pages.last().text().trim();
      var pages_length = last_page_number - 1 ;
      var pages_array_init = 2;
      var pages_array = new Array(pages_length)
        .fill()
        .map(function (value, index) {
          var page_number = pages_array_init + index;
          var url = new URL(page_location);
          url.searchParams.set("page", page_number);
          return {
            page_href: url.toString(),
            page_number,
          };
        })
        .reverse();
      var trigger_delay_ms = 300;
      var is_triggered = false;
      //var is_triggered_finished = false;
      var $collection_product_item_container = $(".collection-product-item-container");
      var $pagination_loading = $(".pagination-loading");
      var button_scroll_container_html = `<div class="button-scroll-container"><button type="button" class="button-scroll"><i class="fas fa-chevron-down"></i> <span>Scroll to view more items</span></button></div>`;

      $("body").prepend(button_scroll_container_html);

      var $button_scroll_container = $(".button-scroll-container");
      var $button_scroll = $button_scroll_container.find(".button-scroll");

      $(window).on("scroll", function() {

        if (pages_array.length === 0) {
          return;
        }

        var scroll_top = $(this).scrollTop();
        var scroll_bottom = scroll_top + window.innerHeight;
        var collection_bottom_offset = $collection_product_item_container.offset().top + $collection_product_item_container.outerHeight();
        var is_bottom = scroll_bottom >= collection_bottom_offset;

        if (is_bottom && !is_triggered) {
          var current_page = pages_array.pop();

          is_triggered = true;
          $pagination_loading.addClass("active");

          $.get(current_page.page_href, function(data) {
            var $data = $(data);
            var $collection_items = $data.find(".collection-product-item-container");
            var collection_items_html = $collection_items.html();

            $collection_product_item_container.append(collection_items_html);
            $pagination_loading.removeClass("active");

            if (!pages_array.length) {
              $button_scroll.hide();
            }

            setTimeout(function() {
              is_triggered = false;
            }, trigger_delay_ms);

          });

        }

      });

    }


    /* ======
      Axis Elite Dropdown Bug Fix for Android
    ====== */

    var is_axis_product = location.pathname.includes("/products/axis-elite");

    if (is_axis_product) {

      var check_bold_option_counter = 0;

      var check_bold_option = setInterval(function() {
        var $bold_dropdowns = $(`.bold_options[data-product-id="1875471728711"] > .bold_option_set`);

        if ($bold_dropdowns.length) {
          clearInterval(check_bold_option);
          var targetNode = $bold_dropdowns[0];
          var config = { attributes: true, childList: true, subtree: true };
    
          var callback = (mutationList, observer) => {
            for (var mutation of mutationList) {
    
              if (mutation.type === "childList") {
                var $target = $(mutation.target);
                var $select = $target.find(`select[name*="properties"]`);
    
                if (!$select.hasClass("needsclick")) $select.addClass("needsclick");
    
              }
    
            }
          };
    
          var observer = new MutationObserver(callback);
          observer.observe(targetNode, config);
        } else if (check_bold_option_counter > 10000) {
          clearInterval(check_bold_option);
        }

        check_bold_option_counter += 100;

      }, 100);

    }

  });
})(jQuery);
